<div class="d-flex flex-row justify-content-between">
  <div class="d-flex flex-row gap-2 align-items-start">
    <div class="pt-1">
      <rs-web-icon
        [color]="iconColor"
        [size]="20"
        [icon]="meter.type | consumptionIcon"
      ></rs-web-icon>
    </div>

    <div class="d-flex flex-column">
      <h2 class="title-m primary-text">
        {{ meter.type | consumptionName: NameDisplayMode.LONG | translate }}
      </h2>

      @if (showZnNumber) {
        <span class="title-xs">ZN {{ meter.deviceId }}</span>
      }
    </div>
  </div>

  @if (selectedConsumption$ | async; as selectedConsumption) {
    @if (selectedConsumption?.consumption) {
      <div class="d-flex flex-column">
        <div class="text-end title-m primary-text">
          {{ selectedConsumption?.consumption?.amount | number: '1.0-2' }}
          {{ ConsumptionUnitType[meter.measurementUnit] }}
        </div>
        <div class="text-end title-xs date">
          {{ selectedConsumption?.consumption?.period?.start | date: 'MMMM yyyy' }}
        </div>
      </div>
    }
  }
</div>
